import * as CryptoJS from 'crypto-js';

/**
 * CryptoStorage позволяет не в явном виде хранить чувствительные данные, не гарантирует защиты данных от взлома.
 */
export class CryptoStorage implements Storage {
  private readonly _storage: Storage;
  private readonly _version: string;
  private readonly _secretKey: string;

  constructor(storage: Storage, version: string, secretKey: string) {
    this._storage = storage;
    this._version = version;
    this._secretKey = secretKey;
  }

  public get length(): number {
    return this._storage.length;
  }

  /**
   * New GUID
   * @return {string}
   */
  public static generateKey(length: number): string {
    let result: string;
    let i: string;
    let j: number;

    result = '';
    for (j = 0; j < length; j++) {
      i = Math.floor(Math.random() * 16).toString(16);
      if (Math.random() > 0.5) {
        i = i.toUpperCase();
      }
      result = result + i;
    }
    return result;
  }

  public static decrypt(data: string, key: string): string {
    let value = CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    const salt = value.substring(0, 32);
    value = value.substring(32);

    const bytes = CryptoJS.AES.decrypt(value, key + salt);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  public static encrypt(value: string, key: string): string {
    const salt = CryptoStorage.generateKey(32);
    const encJson = salt + CryptoJS.AES.encrypt(value, key + salt).toString();
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  }

  public getItem(key: string, storage?: Storage): string | null {
    storage = storage || this._storage;

    const value = storage.getItem(`${key}.${this._version}`);
    if (!value) {
      return null;
    }

    try {
      return CryptoStorage.decrypt(value, this._secretKey || 'test');
    } catch (err) {
      console.warn(err);
      return null;
    }
  }

  public setItem(key: string, value: string, storage?: Storage): void {
    storage = storage || this._storage;
    storage.setItem(
      `${key}.${this._version}`,
      CryptoStorage.encrypt(value, this._secretKey || 'test'),
    );
  }

  public key(index: number, storage?: Storage): string | null {
    storage = storage || this._storage;
    return storage.key(index);
  }

  public removeItem(key: string, storage?: Storage): void {
    storage = storage || this._storage;
    storage.removeItem(`${key}.${this._version}`);
  }

  public clear(storage?: Storage): void {
    storage = storage || this._storage;
    storage.clear();
  }
}
